var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BadgeState',{attrs:{"color":_vm.stateBackground,"label":_vm.stateDisplay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }